import { render, staticRenderFns } from "./HighFiveDemo.vue?vue&type=template&id=6977f843"
import script from "./HighFiveDemo.vue?vue&type=script&lang=js"
export * from "./HighFiveDemo.vue?vue&type=script&lang=js"
import style0 from "./HighFiveDemo.vue?vue&type=style&index=0&id=6977f843&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports